import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/TextInputGroup/text-input-group.mjs';
import { css } from '@patternfly/react-styles';
export const TextInputGroupUtilities = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({ className: css(styles.textInputGroupUtilities, className) }, props, { children: children })));
};
TextInputGroupUtilities.displayName = 'TextInputGroupUtilities';
//# sourceMappingURL=TextInputGroupUtilities.js.map